
import React from 'react'
import Icon from 'react-icon-base'

const MdiCheck = props => (
    <Icon viewBox="0 0 24.00 24.00" {...props}>
        <g>
	<path strokeWidth="0.2" strokeLinejoin="round" d="M 21,7L 9,19L 3.5,13.5L 4.91421,12.0858L 9,16.1716L 19.5858,5.58579L 21,7 Z "/>
</g>
    </Icon>
)

export default MdiCheck
